import { GlobalContext } from "@utils/GlobalContext.js";
import { useContext, useEffect } from "react";
import PhotoCarousel from "./PhotoCarousel";
import { useSpinner } from "./SpinnerContext";
import { useTranslation } from "react-i18next";

export default function PhotoModals() {
  const { photos, seeModal, arePhotosDownloaded, setSeeModal } = useContext(GlobalContext);
  const { showSpinner, hideSpinner } = useSpinner();
  const { t } = useTranslation();
  useEffect(() => {
    if (seeModal) {
      if (!arePhotosDownloaded) {
        showSpinner();
      } else {
        hideSpinner();
      }
    } else {
      hideSpinner();
    }
  }, [seeModal, arePhotosDownloaded]);

  return (
    <>
      {seeModal ? (
        <div
          className="modal fade show fullscreen-overlay"
          id="photoModal"
          aria-hidden="false">
          {arePhotosDownloaded && photos.length > 0? 
          <div className="modal-dialog modal-dialog-centered modal-xl w-100">
            <div className="modal-content border-0 shadow-lg rounded-4 overflow-hidden">
              <div className="modal-body p-0 bg-light">
                <PhotoCarousel />
              </div>
            </div>
          </div> 
          : 
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content border-0 shadow-lg rounded-4 overflow-hidden">
              <i className="close-modal fa-solid fa-xmark fs-1" onClick={() => setSeeModal(false)}></i>
              <div className="modal-body p-5 bg-light text-center">
                <p className="mb-0 fs-5 text-muted">{t("text.no_images_available")}</p>
              </div>
            </div>
          </div>}
        </div>
      ) : null}
    </>
  );
}